import { i18n } from '@/plugins/i18n'

export const ticketStatus = {
    CREATED_BY_USER:    0,
    CREATED_BY_ADMIN:   1,
    SEEN_BY_ADMIN:      2,
    REPLIED_BY_ADMIN:   3,
    SEEN_BY_USER:       4,
    REPLIED_BY_USER:    5,

    CLOSED:                                 6,
    CLOSED_BY_ADMIN_WHEN_CREATED_BY_USER:   7,
    CLOSED_BY_ADMIN_WHEN_CREATED_BY_ADMIN:  8,
    CLOSED_BY_ADMIN_WHEN_SEEN_BY_ADMIN:     9,
    CLOSED_BY_ADMIN_WHEN_REPLIED_BY_ADMIN:  10,
    CLOSED_BY_ADMIN_WHEN_SEEN_BY_USER:      11,
    CLOSED_BY_ADMIN_WHEN_REPLIED_BY_USER:   12,
    CLOSED_BY_TIME_WHEN_CREATED_BY_USER:    13,
    CLOSED_BY_TIME_WHEN_CREATED_BY_ADMIN:   14,
    CLOSED_BY_TIME_WHEN_SEEN_BY_ADMIN:      15,
    CLOSED_BY_TIME_WHEN_REPLIED_BY_ADMIN:   16,
    CLOSED_BY_TIME_WHEN_SEEN_BY_USER:       17,
    CLOSED_BY_TIME_WHEN_REPLIED_BY_USER:    18
}

export const statusStr = {
    CREATED_BY_USER:    i18n.t('ticket.status.pending'),
    CREATED_BY_ADMIN:   i18n.t('ticket.status.pending'),
    SEEN_BY_ADMIN:      i18n.t('ticket.status.under_investigation'),
    REPLIED_BY_ADMIN:   i18n.t('ticket.status.repliedByAdmin'),
    SEEN_BY_USER:       i18n.t('ticket.status.seenByUser'),
    REPLIED_BY_USER:    i18n.t('ticket.status.repliedByUser'),

    CLOSED:                                 i18n.t('ticket.status.closed'),
    CLOSED_BY_ADMIN_WHEN_CREATED_BY_USER:   i18n.t('ticket.status.closed'),
    CLOSED_BY_ADMIN_WHEN_CREATED_BY_ADMIN:  i18n.t('ticket.status.closed'),
    CLOSED_BY_ADMIN_WHEN_SEEN_BY_ADMIN:     i18n.t('ticket.status.closed'),
    CLOSED_BY_ADMIN_WHEN_REPLIED_BY_ADMIN:  i18n.t('ticket.status.closed'),
    CLOSED_BY_ADMIN_WHEN_SEEN_BY_USER:      i18n.t('ticket.status.closed'),
    CLOSED_BY_ADMIN_WHEN_REPLIED_BY_USER:   i18n.t('ticket.status.closed'),
    CLOSED_BY_TIME_WHEN_CREATED_BY_USER:    i18n.t('ticket.status.closed'),
    CLOSED_BY_TIME_WHEN_CREATED_BY_ADMIN:   i18n.t('ticket.status.closed'),
    CLOSED_BY_TIME_WHEN_SEEN_BY_ADMIN:      i18n.t('ticket.status.closed'),
    CLOSED_BY_TIME_WHEN_REPLIED_BY_ADMIN:   i18n.t('ticket.status.closed'),
    CLOSED_BY_TIME_WHEN_SEEN_BY_USER:       i18n.t('ticket.status.closed'),
    CLOSED_BY_TIME_WHEN_REPLIED_BY_USER:    i18n.t('ticket.status.closed'),

    get(status) {
        let status_str = null;
        Object.keys(ticketStatus).forEach(function (item, index) {
            if(ticketStatus[item] === status) {
                status_str = statusStr[item]
            }
        })

        return status_str
    }
}

export const statusVariant = (status) => {
    if(status === ticketStatus.REPLIED_BY_ADMIN) {
        return 'success';
    }

    if (status === ticketStatus.CREATED_BY_USER  ||
        status === ticketStatus.CREATED_BY_ADMIN ||
        status === ticketStatus.REPLIED_BY_USER  ||
        status === ticketStatus.SEEN_BY_ADMIN) {
        return 'warning';
    }

    if (status === ticketStatus.CLOSED                                  ||
        status === ticketStatus.CLOSED_BY_ADMIN_WHEN_CREATED_BY_USER    ||
        status === ticketStatus.CLOSED_BY_ADMIN_WHEN_CREATED_BY_ADMIN   ||
        status === ticketStatus.CLOSED_BY_ADMIN_WHEN_SEEN_BY_ADMIN      ||
        status === ticketStatus.CLOSED_BY_ADMIN_WHEN_REPLIED_BY_ADMIN   ||
        status === ticketStatus.CLOSED_BY_TIME_WHEN_CREATED_BY_USER     ||
        status === ticketStatus.CLOSED_BY_TIME_WHEN_CREATED_BY_ADMIN    ||
        status === ticketStatus.CLOSED_BY_TIME_WHEN_SEEN_BY_ADMIN       ||
        status === ticketStatus.CLOSED_BY_TIME_WHEN_REPLIED_BY_ADMIN    ||
        status === ticketStatus.CLOSED_BY_TIME_WHEN_REPLIED_BY_USER) {
        return 'dark';
    }

    if (status === ticketStatus.CLOSED_BY_ADMIN_WHEN_SEEN_BY_USER ||
        status === ticketStatus.CLOSED_BY_TIME_WHEN_SEEN_BY_USER  ||
        status === ticketStatus.CLOSED_BY_ADMIN_WHEN_REPLIED_BY_USER) {
        return 'primary';
    }

    return 'secondary';
}